package com.nonopn.skywatcher.common.app.home

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.compositionLocalOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import com.nonopn.skywatcher.app.utils.AppBackPressProvider
import com.nonopn.skywatcher.design.local.LocalConfirmPopup
import com.nonopn.skywatcher.design.local.LocalFontSizes
import com.nonopn.skywatcher.design.theme.ApplicationColorTheme
import com.nonopn.skywatcher.design.theme.ApplicationTheme
import com.nonopn.skywatcher.design.theme.createFontSizes
import com.nonopn.skywatcher.design.utils.LocalFrame
import com.nonopn.skywatcher.design.utils.LocalWindow
import com.nonopn.skywatcher.design.utils.LocalWindowProvider
import com.nonopn.skywatcher.design.utils.WindowType
import com.nonopn.skywatcher.design.widgets.defaultBackground
import com.nonopn.skywatcher.design.widgets.popup.PopupConfirmCompose
import com.nonopn.skywatcher.design.widgets.popup.PopupLocalModel
import eu.codlab.compose.theme.LocalDarkTheme
import eu.codlab.viewmodel.effects.LifecycleEffect

var staticModel: AppModel? = null

val LocalApp = compositionLocalOf<AppModel> { error("No StaticModel, check LocalApp") }
val LocalIsPreview = compositionLocalOf { false }

@Composable
fun AppCommon(
    isDarkTheme: Boolean,
    onBackPressed: AppBackPressProvider = AppBackPressProvider(),
    createAppModel: (isSystemDarkMode: Boolean) -> AppModel = { AppModel.fake() },
) {
    LifecycleEffect {
        println("Having a new lifecycle state $it")
    }

    LocalWindowProvider(Modifier.fillMaxSize()) {
        InternalApp(
            isDarkTheme,
            onBackPressed,
            createAppModel
        ) {
            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .defaultBackground()
            ) {
                AppContent()

                PopupConfirmCompose()
            }
        }
    }
}

@Composable
fun PreviewApp(
    modifier: Modifier = Modifier,
    windowType: WindowType = WindowType.TABLET,
    frameType: WindowType = WindowType.TABLET,
    isDarkTheme: Boolean,
    onBackPressed: AppBackPressProvider = AppBackPressProvider(),
    isPreview: Boolean = false,
    createAppModel: (isSystemDarkMode: Boolean) -> AppModel = { AppModel.fake() },
    content: @Composable () -> Unit
) {
    CompositionLocalProvider(
        LocalWindow provides windowType,
        LocalFrame provides frameType,
        LocalIsPreview provides isPreview
    ) {
        InternalApp(
            isDarkTheme,
            onBackPressed,
            createAppModel
        ) {
            Column(modifier.fillMaxSize().defaultBackground()) {
                content()
            }
        }
    }
}

@Composable
private fun InternalApp(
    isDefaultDarkTheme: Boolean,
    onBackPressed: AppBackPressProvider = AppBackPressProvider(),
    createAppModel: (isSystemDarkMode: Boolean) -> AppModel,
    content: @Composable () -> Unit
) {
    val confirmPopup by remember { mutableStateOf(PopupLocalModel()) }
    val fontSizes = createFontSizes()

    if (null == staticModel) {
        staticModel = createAppModel(
            true // isDefaultDarkTheme
        )
    }
    val model = staticModel!!
    val state by model.states.collectAsState()
    //TODO introduce ability to override and reintroduce system's
    val isDarkTheme = state.isSystemDarkMode

    LaunchedEffect(onBackPressed) {
        model.onBackPressed = onBackPressed
    }

    CompositionLocalProvider(
        LocalConfirmPopup provides confirmPopup,
        LocalApp provides model,
        LocalFontSizes provides fontSizes,
        LocalDarkTheme provides isDarkTheme
    ) {
        ApplicationColorTheme(isDarkTheme) {
            ApplicationTheme(isDarkTheme, content)
        }
    }
}
